import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError, tap } from 'rxjs/operators';
import { concat, EMPTY, from, Observable, of } from 'rxjs';
import { LoadDataRequest, LoadDataRequestAtlas } from '../../global/interfaces';
import { createPostQuery } from '../../shared/utils';
import * as statements from './statements.actions';

import { HttpService } from '../../global/http.service';
import { downloadFile, downloadZipFile } from '../../global/fileDownload';
import { LoadDocumentsResponse } from '../documents/documents.models';
import { HttpResponse } from '@angular/common/http';
import { ToastService } from '../../shared/toaster_/toaster_.service';
import { Actions as ActionsCDK } from "atlas-cdk";

@Injectable()
export class StatementEffects {
  public paginationFilter;
  public loadStatementTypes$ = createEffect(() => this.actions$.pipe(
    ofType<statements.LoadStatementTypesAction>(statements.ActionTypes.LOAD_STATEMENT_TYPES),
    map(action => action.payload),
    switchMap((payload) =>
      this.loadStatementTypes(payload).pipe(
        map((response: string[]) =>
          new statements.LoadStatementTypesSuccessAction(response)
        ),
        catchError(error => from([
          new statements.LoadStatementTypesFailedAction(error)
        ]))
      )
    )
  ));

  // public loadStatements$ = createEffect(() => this.actions$.pipe(
  //   ofType<statements.LoadStatementsAction>(statements.ActionTypes.LOAD_STATEMENTS),
  //   map(action => action.payload),
  //   switchMap(payload =>
  //     this.loadStatements(payload).pipe(
  //       map((response: LoadDocumentsResponse) => {
  //         return new statements.LoadStatementsSuccessAction(response);
  //       }),
  //       catchError(error =>
  //       (from([
  //         new statements.LoadStatementsFailedAction(error),
  //         new AddErrorToastAction(error.error.message)
  //       ])
  //       ))
  //     )
  //   )
  // ));
  public loadStatements$ = createEffect(() => this.actions$.pipe(
    ofType<statements.LoadStatementsAction>(statements.ActionTypes.LOAD_STATEMENTS),
    map(action => action.payload),
    switchMap(payload =>
      this.loadStatements(payload).pipe(
        map((response: LoadDocumentsResponse) => {
          return new statements.LoadStatementsSuccessAction(response);
        }),
        catchError(error =>
          // from([
          //   new statements.LoadStatementsFailedAction(error),
          //   new AddErrorToastAction(error.error.message)
          // ])
          // {
          //   this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
          //   return of(new statements.LoadStatementsFailedAction(error));
          // }
          concat(
            of(new statements.LoadStatementsFailedAction(error)),
            of(null).pipe(
              tap(() => {
                this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));
  /**
   * Load statements for mobile
   * Uses same endpoint as desktop version
   */
  public loadMobileStatements$ = createEffect(() => this.actions$.pipe(
    ofType<statements.LoadMobileStatementsAction>(statements.ActionTypes.LOAD_MOBILE_STATEMENTS),
    map(action => action.payload),
    switchMap(payload =>
      this.loadStatements(payload).pipe(
        map((response: LoadDocumentsResponse) =>
          new statements.LoadMobileStatementsSuccessAction(response)
        ),
        catchError(error =>
        (from([
          new statements.LoadMobileStatementsFailedAction(error)
        ]))
        )
      )
    )
  ));

  public fileDownload$ = createEffect(() => this.actions$.pipe(
    ofType<statements.StatementsFileDownloadAction>(statements.ActionTypes.STATEMENTS_FILE_DOWNLOAD),
    map(action => action.payload),
    switchMap(payload =>
      this.downloadStatementsFile(payload.id).pipe(
        map((response: any) => {
          // deepcode ignore DOMXSS:internally created secure response
          downloadFile(response.body, 'Application/pdf', payload.originalName);
        }),
        catchError(() => {
          // from([
          //   new AddErrorToastAction('Download failed. Please try again later.')
          // ])

          this._toasterService.launchAlertError('Download failed. Please try again later.', ActionsCDK.error);
          return EMPTY;
        }
        )
      )
    )
  ), { dispatch: false });

  public zipFileDownload$ = createEffect(() => this.actions$.pipe(
    ofType<statements.DownloadStatementsZipAction>(statements.ActionTypes.DOWNLOAD_STATEMENTS_ZIP),
    map(action => action.payload),
    switchMap(payload =>
      this.zipFileDownload(payload).pipe(
        map((response: HttpResponse<Blob>) => {

          // deepcode ignore DOMXSS:internally created secure response
          downloadZipFile(response.body, payload.originalName);

          //return new AddErrorToastAction('Download failed. Invalid file format.');
          // {
          //   return this._toasterService.launchAlertError('Download failed. Invalid file format.', ActionsCDK.error);
          // }

        }),
        catchError(() => {
          // from([
          //   new AddErrorToastAction('Download failed. Please try again later.')
          // ])

          this._toasterService.launchAlertError('Download failed. Please try again later.', ActionsCDK.error);
          return EMPTY;
        }
        )
      )
    )
  ), { dispatch: false });

  public constructor(
    private readonly actions$: Actions,
    private readonly http: HttpService,
    private readonly _toasterService: ToastService
  ) {
  }

  private loadStatementTypes(payload: any): Observable<string[]> {
    return this.http.post(`/documents/subtypes`, payload, { withCredentials: true });
  }

  private loadStatements(payload: LoadDataRequestAtlas): Observable<LoadDocumentsResponse> {
    return this.http.post(`/library`, createPostQuery(payload), { withCredentials: true });
  }

  private downloadStatementsFile(id: string): Observable<any> {
    return this.http.get(`/documents/${id}`, {
      observe: 'response',
      responseType: 'blob'
    });
  }

  private zipFileDownload(payload: LoadDataRequest): Observable<HttpResponse<Blob>> {
    const { account, country, from, to, type, subtype } = payload;
    const filteredPayload = { account, country, from, to, type, subtype };
    return this.http.post('/documents/zipExport', createPostQuery(filteredPayload), {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
